import React, { useContext } from 'react';
import { StateContext } from '../../../state/index';
import ConfigComponent from '../../ConfigComponent';
import Title from '../../library/Title';
import { actions } from '../../../state/actions';
import { TOKEN_TYPES } from '../../../utils/enums';
import { Button, ButtonContainer } from '../../../components/library/Buttons';
import StartOver from '../../../components/library/StartOver';

export const ACHAcceptView = ({ children, onSubmit, isFetching }) => {
  const [{ configuration, tokens }, dispatch] = useContext(StateContext);

  // const {
  //   additional_data: {
  //     network_response: {
  //       payment_instrument: { name, bank_code, masked_account_number },
  //     },
  //   },
  // } = tokens[TOKEN_TYPES.RECIPIENT_LOGIN];

  const {
    additional_data: {
      user_data: { name, bank_code, account_number },
    },
  } = tokens[TOKEN_TYPES.RECIPIENT_LOGIN];

  return (
    <>
      <Title>
        <h1>Accept Payment</h1>
      </Title>
      <section className="main">
        <p className="description">
          <ConfigComponent config={configuration.acceptPayment.description} />
        </p>
        <div style={{ padding: '1em' }}>
          <div>
            <div>
              <span
                style={{
                  fontWeight: 'bold',
                  display: 'inline-block',
                  width: 165,
                  textAlign: 'right',
                  paddingRight: 5,
                }}
              >
                Name on Account:{' '}
              </span>
              {name}
            </div>
            <div>
              <span
                style={{
                  fontWeight: 'bold',
                  display: 'inline-block',
                  width: 165,
                  textAlign: 'right',
                  paddingRight: 5,
                }}
              >
                Account Number:{' '}
              </span>
              {account_number}
            </div>
            <span
              style={{
                fontWeight: 'bold',
                display: 'inline-block',
                width: 165,
                textAlign: 'right',
                paddingRight: 5,
              }}
            >
              Routing Number:{' '}
            </span>
            {bank_code}
          </div>
        </div>

        {configuration.acceptPayment.secondaryText && (
          <p className="description">
            <ConfigComponent
              config={configuration.acceptPayment.secondaryText}
            />
          </p>
        )}

        <ButtonContainer horizontal style={{ paddingBottom: 10 }}>
          <Button
            onClick={() =>
              dispatch(
                actions.tokens.setToken(TOKEN_TYPES.RECIPIENT_LOGIN, null)
              )
            }
            label="Back"
            small
          />
          <Button
            onClick={onSubmit}
            label="Confirm"
            disabled={isFetching}
            small
            inverted
          />
        </ButtonContainer>
        <StartOver />
      </section>
    </>
  );
};

export default ACHAcceptView;
